import { SubMenu } from './SubMenu';

class Menu {
  constructor(params) {
    this.name = params.name;
    this.id = params.id;
    this.imageUrl = params.imageUrl;
    this.index = params.index;
    this.subMenus = (params.subMenus || []).map(data => new SubMenu(data));
  }
}

export { Menu };



// WEBPACK FOOTER //
// ./src/models/Menu.js